import { CommonButton } from 'components/common/Forms/Button';
import { useUnassignedTrustBookingSites } from 'context/patient/modules/booking';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useCallback } from 'react';

import { SiteData } from '../../../types/sites';
import {
  PatientBookingSiteItem,
  PatientBookingSiteItemName,
} from './PatientBooking.styled';
import { patientAddToHospitalUri } from 'routes/AppRoutes';
import { useHistory } from 'react-router';

export const PatientBookingPickSiteUnassignedTrustList = () => {
  const { t } = useCommonTranslation();
  const { sites } = useUnassignedTrustBookingSites();
  const { push } = useHistory();

  const addSiteHandler = useCallback(
    (site: SiteData) => push(patientAddToHospitalUri(site.id)),
    [push],
  );

  return (
    <>
      {sites?.map((site) => (
        <PatientBookingSiteItem key={site.id}>
          <PatientBookingSiteItemName>{site.name}</PatientBookingSiteItemName>
          <CommonButton
            variant="primary"
            onClick={() => {
              addSiteHandler(site);
            }}
          >
            {t('select')}
          </CommonButton>
        </PatientBookingSiteItem>
      ))}
    </>
  );
};
